import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDash24pxGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M5 8H11"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  );
};

export const IconDash24pxSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconDash24pxGroup {...props} />
    </svg>
  );
};
